import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxuryurbaniaonrentinpashan() {



    const cardData =
    {
        keyword: 'Luxury Urbania On Rent in Pashan',
        heading: 'Urbania on rent in pune: Luxury Urbania On Rent in Pashan',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Luxury Urbania On Rent in Pashan for corporate executives, families, tourists, and event travelers seeking comfortable and stylish transportation. Our well‑maintained Force Urbania luxury fleet provides spacious seating, air-conditioned comfort, and a smooth ride, making it ideal for corporate travel, airport transfers, weddings, sightseeing, and outstation journeys from Pashan. With professional chauffeurs, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from Pashan, Aundh, Baner, Wakad, Kothrud, Kharadi, and Pune Airport, we ensure a refined and stress‑free travel experience. Backed by 24/7 booking support, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for luxury Urbania hire in Pashan..',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical fort and a powerful symbol of Maratha pride. Once the administrative center of Bajirao I, it features massive stone walls, majestic gates like the Delhi Darwaza, and spacious courtyards. Although a major fire destroyed much of the structure, the remaining fort reflects royal grandeur. The evening light-and-sound show narrates Maratha history, making it a must-visit heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is one of Pune’s most important landmarks connected to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. The palace now houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Its Italian-style arches, lush lawns, and peaceful environment make it both historically significant and visually stunning."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous and revered Ganesh temple. The idol is richly adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of Pune’s grand celebrations with processions and cultural programs. The temple trust is also well known for its social and charitable initiatives, making it spiritually and socially significant."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fortress located amidst the Sahyadri ranges and is famous for the legendary battle fought by Tanaji Malusare. The fort offers panoramic views of Pune city, ancient bastions, memorials, and scenic trekking routes. Visitors enjoy traditional Maharashtrian food like pithla-bhakri at the top. It is a perfect destination combining history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi mandap, and ancient carvings reflecting early Indian craftsmanship. Despite being located in a busy area, the temple maintains a calm and spiritual ambiance, offering a peaceful retreat within the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected from across India, showcasing traditional art, musical instruments, sculptures, and household items. One of its highlights is the recreated Mastani Mahal. The museum offers deep insight into India’s cultural heritage and is a treasure trove for history lovers, students, and art enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks and offers breathtaking panoramic views after climbing 103 stone steps. The hilltop Parvati Temple, built during the Peshwa era, is dedicated to Lord Shiva and Goddess Parvati. The complex also includes smaller shrines and a museum. Sunrise and sunset views from the hill are especially captivating."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a globally renowned center for meditation, mindfulness, and wellness. Surrounded by lush gardens, it attracts visitors from around the world seeking peace, relaxation, and self-discovery. The serene atmosphere and unique meditation techniques make it a distinctive spiritual destination in Pune."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing water streams, stone bridges, manicured lawns, and seasonal flowers. The garden offers a peaceful environment for walks, photography, and family outings, beautifully blending Japanese aesthetics with Indian natural beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular picnic and leisure spot near Pune. The expansive water body, surrounding hills, and cool breezes create a scenic setting, especially during monsoon and evenings. Local vendors selling corn and tea add to its charm. It also serves as the gateway to Sinhagad Fort, making it a favorite weekend getaway."
  }
],



"services": [
    {
      "name": "Luxury Urbania on Rent in Pashan",
      "description": "Luxury Urbania on Rent in Pashan offers premium Urbania vehicles designed for travelers who seek comfort, elegance, and reliability. Ideal for corporate travel, family tours, and special occasions, the service features plush interiors, air-conditioned comfort, spacious seating, and professional chauffeurs for a smooth and stylish journey."
    },
    {
      "name": "Pashan Urbania Luxury Bus Hire",
      "description": "Pashan Urbania Luxury Bus Hire provides high-end buses suitable for group travel, corporate events, and social gatherings. With superior ride quality, well-maintained interiors, and experienced chauffeurs, this service ensures comfortable and organized transportation from Pashan to any destination."
    },
    {
      "name": "Premium Urbania Rental Pashan Pune",
      "description": "Premium Urbania Rental Pashan Pune delivers top-quality Urbania vehicles tailored for luxury travel needs. Designed for executives, families, and VIP guests, the service focuses on comfort, punctuality, and professional chauffeur-driven transportation."
    },
    {
      "name": "Urbania AC Luxury Bus Pashan",
      "description": "Urbania AC Luxury Bus Pashan offers fully air-conditioned buses with premium interiors for a relaxed travel experience. Ideal for long-distance journeys, weddings, and corporate tours, this service ensures climate-controlled comfort and smooth highway performance."
    },
    {
      "name": "Corporate Luxury Urbania Hire Pashan",
      "description": "Corporate Luxury Urbania Hire Pashan provides executive transportation solutions for businesses and professionals. With punctual service, refined interiors, and trained chauffeurs, it is perfect for meetings, conferences, airport transfers, and corporate events."
    },
    {
      "name": "Luxury Urbania for Outstation Pashan",
      "description": "Luxury Urbania for Outstation Pashan ensures safe and comfortable long-distance travel with highway-experienced chauffeurs. Ideal for intercity trips, tours, and pilgrimages, this service emphasizes reliability, comfort, and premium travel experience."
    },
    {
      "name": "Luxury Airport Transfer Urbania Pashan",
      "description": "Luxury Airport Transfer Urbania Pashan offers timely and elegant airport pickup and drop services. With spacious luggage capacity, air-conditioned comfort, and professional chauffeurs, it ensures stress-free transfers to and from Pune Airport."
    },
    {
      "name": "Chauffeur Driven Luxury Urbania Pashan",
      "description": "Chauffeur Driven Luxury Urbania Pashan delivers stress-free and premium travel with trained, background-verified drivers. Vehicles are meticulously maintained, allowing passengers to enjoy a smooth, safe, and relaxed journey."
    },
    {
      "name": "Wedding Luxury Urbania Pashan",
      "description": "Wedding Luxury Urbania Pashan provides elegant transportation solutions for wedding ceremonies, receptions, and guest movement. With plush interiors, professional chauffeurs, and punctual service, it ensures smooth wedding-day travel."
    },
    {
      "name": "Family Tour Luxury Urbania Pashan",
      "description": "Family Tour Luxury Urbania Pashan offers spacious and comfortable vehicles for family vacations and group outings. With ample seating, luggage space, and smooth ride quality, families can enjoy relaxed and enjoyable journeys."
    },
    {
      "name": "Best Luxury Urbania Rental Pashan Pune",
      "description": "Best Luxury Urbania Rental Pashan Pune is known for top-rated service quality, premium vehicles, and customer satisfaction. Ideal for all luxury travel needs, it guarantees a reliable, comfortable, and stylish travel experience."
    },
    {
      "name": "Comfortable Luxury Urbania Pashan",
      "description": "Comfortable Luxury Urbania Pashan focuses on providing a smooth and relaxed ride experience. With spacious seating, climate control, and refined interiors, passengers enjoy superior comfort throughout their journey."
    },
    {
      "name": "Executive Urbania Hire Pashan",
      "description": "Executive Urbania Hire Pashan offers premium transportation for executives, business leaders, and VIP guests. With professional chauffeur service, elegant interiors, and punctual operations, it ensures seamless executive travel."
    },
    {
      "name": "High End Urbania Rental Pashan",
      "description": "High End Urbania Rental Pashan delivers luxury-grade Urbania vehicles equipped with superior features and comfort. Perfect for special occasions, corporate travel, and premium tours, it provides a refined and dependable travel solution."
    },
    {
      "name": "Trusted Luxury Urbania Service Pashan",
      "description": "Trusted Luxury Urbania Service Pashan emphasizes reliability, safety, and premium customer experience. With experienced chauffeurs, well-maintained vehicles, and consistent service quality, it ensures complete peace of mind for luxury travel."
    }
  ],
  "tableData": [
    ["Luxury Urbania on Rent in Pashan", "Pashan Urbania Luxury Bus Hire"],
    ["Premium Urbania Rental Pashan Pune", "Urbania AC Luxury Bus Pashan"],
    ["Corporate Luxury Urbania Hire Pashan", "Luxury Urbania for Outstation Pashan"],
    ["Luxury Airport Transfer Urbania Pashan", "Chauffeur Driven Luxury Urbania Pashan"],
    ["Wedding Luxury Urbania Pashan", "Family Tour Luxury Urbania Pashan"],
    ["Best Luxury Urbania Rental Pashan Pune", "Comfortable Luxury Urbania Pashan"],
    ["Executive Urbania Hire Pashan", "High End Urbania Rental Pashan"],
    ["Trusted Luxury Urbania Service Pashan", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Premium Luxury Urbania On Rent in Pashan",
        "WhyChoosedescription": "Luxury Urbania On Rent in Pashan is ideal for travelers seeking a comfortable, spacious, and stylish ride for family outings, corporate trips, events, and long journeys."
    },
    {
        "WhyChooseheading": "Stylish and Well‑Maintained Force Urbania Vehicles",
        "WhyChoosedescription": "Luxury Urbania On Rent in Pashan offers top‑of‑the‑line Force Urbania vehicles with elegant interiors, plush seating, and modern amenities for a premium travel experience."
    },
    {
        "WhyChooseheading": "Professional and Courteous Drivers",
        "WhyChoosedescription": "Luxury Urbania On Rent in Pashan comes with experienced and courteous drivers who ensure safe, smooth, and respectful service throughout your journey."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "Choose Luxury Urbania On Rent in Pashan for competitive and transparent pricing with no hidden charges, offering excellent value for premium travel."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Luxury Urbania On Rent in Pashan provides round‑the‑clock booking assistance and customer support for seamless travel planning."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Luxury Urbania On Rent in Pashan is available for hourly rentals, full‑day bookings, airport transfers, wedding transportation, and customized travel packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well‑Maintained Vehicles",
        "WhyChoosedescription": "All vehicles for Luxury Urbania On Rent in Pashan are regularly cleaned, sanitized, and serviced to maintain high standards of hygiene and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Luxury Urbania On Rent in Pashan guarantees on‑time pickups and dependable service for smooth, stress‑free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Luxury Urbania On Rent in Pashan available for both local and outstation travel?',
        answer: 'Yes, Luxury Urbania On Rent in Pashan can be booked for local city travel as well as long‑distance and outstation journeys.',
    },
    {
        question: 'How can I book Luxury Urbania On Rent in Pashan?',
        answer: 'You can book Luxury Urbania On Rent in Pashan via phone, WhatsApp, or online booking for quick and hassle‑free reservations.',
    },
    {
        question: 'Why choose Luxury Urbania On Rent in Pashan for group travel?',
        answer: 'Luxury Urbania On Rent in Pashan offers spacious seating, premium interiors, and a smooth ride, making it ideal for families, corporate groups, and events.',
    },
    {
        question: 'Is Luxury Urbania On Rent in Pashan suitable for weddings and events?',
        answer: 'Yes, Luxury Urbania On Rent in Pashan is perfect for weddings, receptions, corporate events, and special occasions.',
    },
    {
        question: 'Are drivers experienced with Luxury Urbania On Rent in Pashan?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in providing smooth and comfortable journeys.',
    },
    {
        question: 'Can I customize pickup and drop‑off locations?',
        answer: 'Absolutely. Luxury Urbania On Rent in Pashan allows flexible pickup and drop‑off locations across Pashan, Pune, and nearby areas.',
    },
    {
        question: 'Is Luxury Urbania On Rent in Pashan available 24x7?',
        answer: 'Yes, Luxury Urbania On Rent in Pashan operates 24x7 to meet your travel needs any time of day or night.',
    },
    {
        question: 'Are vehicles sanitized and maintained regularly?',
        answer: 'Yes, all vehicles are cleaned, sanitized, and serviced regularly with high hygiene and safety standards.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Luxury Urbania On Rent in Pashan accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout your trip to ensure a smooth and stress‑free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Aditya Kulkarni',
        feedback: 'We booked Luxury Urbania On Rent in Pashan for a family trip. The vehicle was luxurious, clean, and very comfortable. Highly recommended!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Meera Deshpande',
        feedback: 'Luxury Urbania On Rent in Pashan provided exceptional service for our corporate event. Professional driver and premium interiors made the trip memorable.',
        rating: 5,
    },
];










































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Urbania On Rent in Pashan",
  "image": "https://urbaniaonrentpune.in/assets/images/luxury-urbania-pashan.jpg",
  "description": "Luxury Urbania On Rent in Pashan offers premium AC Urbania buses for corporate trips, outstation travel, airport transfers, weddings, family tours, and executive travel. Chauffeur-driven luxury buses ensure safe, comfortable, and convenient transportation in Pashan and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/luxury-urbania-on-rent-pashan"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Luxury Urbania On Rent in Pashan | Premium AC Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Luxury Urbania On Rent in Pashan for corporate trips, outstation travel, airport transfers, weddings, family tours, and executive travel. Premium AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Pashan Pune."
  />

  <meta
    name="keywords"
    content="Luxury Urbania on Rent in Pashan, Pashan Urbania Luxury Bus Hire, Premium Urbania Rental Pashan Pune, Urbania AC Luxury Bus Pashan, Corporate Luxury Urbania Hire Pashan, Luxury Urbania for Outstation Pashan, Luxury Airport Transfer Urbania Pashan, Chauffeur Driven Luxury Urbania Pashan, Wedding Luxury Urbania Pashan, Family Tour Luxury Urbania Pashan, Best Luxury Urbania Rental Pashan Pune, Comfortable Luxury Urbania Pashan, Executive Urbania Hire Pashan, High End Urbania Rental Pashan, Trusted Luxury Urbania Service Pashan"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/53.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Luxuryurbaniaonrentinpashan;